import { NotificationPermission, ContextValue, ImpersonatedUser } from "./types";

export const initialUser = {
  firstName: "",
  lastName: "",
};

export const initialPreferences = {
  acknowledgedNotificationBadgeState: NotificationPermission.UNDETERMINED,
  acknowledgedEmailChangeExpired: false,
  jobSearches: [],
};

export const initialUserContext: ContextValue = {
  ...initialUser,
  ...initialPreferences,
  loaded: false,
  logout() {},
  setAcknowledgedEmailChangeExpired(_: boolean) {},
  setAcknowledgedNotificationBadgeState(_: NotificationPermission) {},
  addJobSearch() {},
  clearJobSearches() {},
  setCurrentUser() {},
  impersonatedUser: null,
  canImpersonate: false,
  assumeUser(_: ImpersonatedUser) {},
  clearAssumedUser() {},
};
